export default function getGeoInformation(infoType: string) {
  let apiAddress = '';
  switch (infoType) {
    case 'geocode':
      apiAddress = 'https://api.bigdatacloud.net/data/reverse-geocode-client';
      break;
    case 'client_ip':
      apiAddress = 'https://api.bigdatacloud.net/data/client-ip';
      break;
  }

  const request = new XMLHttpRequest();
  request.open('GET', apiAddress, false);
  request.send();
  return JSON.parse(request.response);
}
